import type { IIconProps } from '@app/components/Icon/types'
import type React from 'react'

interface IIconIoeAdProps extends IIconProps {}

const IconIoeAd: React.FC<IIconIoeAdProps> = props => {
  const size = props.size ?? 20

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.77055 10.694L6.867 12.5762M7.0852 3.7831L3.43729 8.80222M12.5628 8.80234L8.91527 3.78373M9.13297 12.5762L12.2295 10.694M8.00001 4.15755V11.917M8.00001 4.15755C8.71602 4.15755 9.29645 3.58449 9.29645 2.8776C9.29645 2.17071 8.71602 1.59766 8.00001 1.59766C7.284 1.59766 6.70356 2.17071 6.70356 2.8776C6.70356 3.58449 7.284 4.15755 8.00001 4.15755ZM8.00001 11.917C7.284 11.917 6.70356 12.4901 6.70356 13.197C6.70356 13.9038 7.284 14.4769 8.00001 14.4769C8.71602 14.4769 9.29645 13.9038 9.29645 13.197C9.29645 12.4901 8.71602 11.917 8.00001 11.917ZM4.05705 9.89315C4.05705 10.6 3.47662 11.1731 2.76061 11.1731C2.0446 11.1731 1.46416 10.6 1.46416 9.89315C1.46416 9.18626 2.0446 8.61321 2.76061 8.61321C3.47662 8.61321 4.05705 9.18626 4.05705 9.89315ZM14.5359 9.89315C14.5359 10.6 13.9554 11.1731 13.2394 11.1731C12.5234 11.1731 11.943 10.6 11.943 9.89315C11.943 9.18626 12.5234 8.61321 13.2394 8.61321C13.9554 8.61321 14.5359 9.18626 14.5359 9.89315Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default IconIoeAd
